"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var graph_1 = require("./shared/graph");
var lifecycle_1 = require("./shared/lifecycle");
var form_1 = require("./models/form");
var validator_1 = require("@formily/validator");
var shared_1 = require("@formily/shared");
var types_1 = require("./types");
exports.createFormInternals = function (options) {
    if (options === void 0) { options = {}; }
    function onFormChange(published) {
        var dirtys = form.dirtys;
        if (dirtys.values) {
            notifyFormValuesChange();
        }
        if (dirtys.initialValues) {
            if (!env.uploading) {
                form.setState(function (state) {
                    state.values = shared_1.defaults(published.initialValues, published.values);
                });
            }
            notifyFormInitialValuesChange();
        }
        if (dirtys.unmounted && published.unmounted) {
            heart.publish(types_1.LifeCycleTypes.ON_FORM_UNMOUNT, form);
        }
        if (dirtys.mounted && published.mounted) {
            heart.publish(types_1.LifeCycleTypes.ON_FORM_MOUNT, form);
        }
        if (dirtys.initialized) {
            heart.publish(types_1.LifeCycleTypes.ON_FORM_INIT, form);
        }
        heart.publish(types_1.LifeCycleTypes.ON_FORM_CHANGE, form);
        if (env.hostRendering) {
            env.hostRendering =
                dirtys.values || dirtys.initialValues || dirtys.editable;
        }
        return env.hostRendering;
    }
    function notifyFormValuesChange() {
        if (shared_1.isFn(options.onChange) && form.state.mounted && !form.state.unmounted) {
            clearTimeout(env.onChangeTimer);
            env.onChangeTimer = setTimeout(function () {
                if (form.state.unmounted)
                    return;
                options.onChange(shared_1.clone(getFormValuesIn('')));
            });
        }
        heart.publish(types_1.LifeCycleTypes.ON_FORM_VALUES_CHANGE, form);
    }
    function notifyFormInitialValuesChange() {
        heart.publish(types_1.LifeCycleTypes.ON_FORM_INITIAL_VALUES_CHANGE, form);
    }
    function onGraphChange(_a) {
        var type = _a.type, payload = _a.payload;
        heart.publish(types_1.LifeCycleTypes.ON_FORM_GRAPH_CHANGE, graph);
        if (type === 'GRAPH_NODE_WILL_UNMOUNT') {
            validator.unregister(payload.path.toString());
        }
    }
    function setFormIn(path, key, value, silent) {
        var method = silent ? 'setSourceState' : 'setState';
        form[method](function (state) {
            shared_1.FormPath.setIn(state[key], getDataPath(path), value);
            if (key === 'values') {
                state.modified = true;
            }
        }, silent);
    }
    function deleteFormIn(path, key, silent) {
        var method = silent ? 'setSourceState' : 'setState';
        form[method](function (state) {
            shared_1.FormPath.deleteIn(state[key], getDataPath(path));
            if (key === 'values') {
                state.modified = true;
            }
        }, silent);
    }
    function deleteFormValuesIn(path, silent) {
        deleteFormIn(path, 'values', silent);
    }
    function setFormValuesIn(path, value, silent) {
        return setFormIn(path, 'values', value, silent);
    }
    function setFormInitialValuesIn(path, value, silent) {
        return setFormIn(path, 'initialValues', value, silent);
    }
    function getFormIn(path, key) {
        return form.getState(function (state) { return shared_1.FormPath.getIn(state[key], getDataPath(path)); });
    }
    function getFormValuesIn(path) {
        return getFormIn(path, 'values');
    }
    function existFormValuesIn(path) {
        return form.getState(function (state) {
            return shared_1.FormPath.existIn(state.values, getDataPath(path));
        });
    }
    function getFormInitialValuesIn(path) {
        return getFormIn(path, 'initialValues');
    }
    function getDataPath(path) {
        var newPath = shared_1.FormPath.getPath(path);
        return newPath.reduce(function (path, key, index) {
            if (index >= newPath.length - 1)
                return path.concat([key]);
            var realPath = newPath.slice(0, index + 1);
            var dataPath = path.concat([key]);
            var selected = graph.get(realPath);
            if (types_1.isVirtualField(selected)) {
                return path;
            }
            return dataPath;
        }, shared_1.FormPath.getPath(''));
    }
    function matchStrategy(pattern, nodePath) {
        var matchPattern = shared_1.FormPath.parse(pattern);
        var node = graph.get(nodePath);
        if (!node)
            return false;
        return node.getSourceState(function (state) {
            return matchPattern.matchAliasGroup(state.name, state.path);
        });
    }
    function updateRecoverableShownState(parentState, childState, name) {
        var lastShownState = env.lastShownStates[childState.path];
        var lastStateValue = childState[name];
        if (parentState[name] && lastShownState && lastShownState[name] === false) {
            childState[name] = false;
            delete lastShownState[name];
            if (!lastShownState.hasOwnProperty('visible') &&
                !lastShownState.hasOwnProperty('display')) {
                delete env.lastShownStates[childState.path];
            }
        }
        else {
            childState[name] = parentState[name];
        }
        if (!parentState[name] && !lastStateValue) {
            if (!lastShownState) {
                env.lastShownStates[childState.path] = {};
            }
            env.lastShownStates[childState.path][name] = false;
        }
    }
    function resetFormMessages(fieldState) {
        var path = fieldState.path, visible = fieldState.visible, display = fieldState.display, unmounted = fieldState.unmounted, editable = fieldState.editable;
        if (editable === false ||
            visible === false ||
            unmounted === true ||
            display === false) {
            form.setState(function (state) {
                var _a, _b, _c, _d;
                var newErrors = (_b = (_a = state.errors) === null || _a === void 0 ? void 0 : _a.reduce) === null || _b === void 0 ? void 0 : _b.call(_a, function (buf, item) {
                    if (item.path === path) {
                        return buf;
                    }
                    else {
                        return buf.concat(item);
                    }
                }, []);
                var newWarnings = (_d = (_c = state.warnings) === null || _c === void 0 ? void 0 : _c.reduce) === null || _d === void 0 ? void 0 : _d.call(_c, function (buf, item) {
                    if (item.path === path) {
                        return buf;
                    }
                    else {
                        return buf.concat(item);
                    }
                }, []);
                var errorsChanged = !shared_1.isEqual(state.errors, newErrors);
                var warningsChanged = !shared_1.isEqual(state.warnings, newWarnings);
                if (warningsChanged) {
                    state.warnings = newWarnings;
                }
                if (errorsChanged) {
                    state.errors = newErrors;
                }
            });
        }
    }
    function syncFormMessages(type, fieldState, silent) {
        var name = fieldState.name, path = fieldState.path;
        var messages = fieldState[type];
        form.setState(function (state) {
            var _a, _b;
            var foundField = false;
            var newMessages = (_b = (_a = state[type]) === null || _a === void 0 ? void 0 : _a.reduce) === null || _b === void 0 ? void 0 : _b.call(_a, function (buf, item) {
                if (item.path === path) {
                    foundField = true;
                    return messages.length ? buf.concat({ name: name, path: path, messages: messages }) : buf;
                }
                else {
                    return buf.concat(item);
                }
            }, []);
            var messageChanged = !shared_1.isEqual(state[type], newMessages);
            if (messageChanged) {
                state[type] = newMessages;
            }
            if (!foundField && messages.length) {
                state[type].push({
                    name: name,
                    path: path,
                    messages: messages
                });
            }
        }, silent);
    }
    function batchRunTaskQueue(field, nodePath) {
        for (var index = 0; index < env.taskQueue.length; index++) {
            var _a = env.taskQueue[index], pattern = _a.pattern, callbacks = _a.callbacks;
            var removed = false;
            if (matchStrategy(pattern, nodePath)) {
                callbacks.forEach(function (callback) {
                    field.setState(callback);
                });
                if (!pattern.isWildMatchPattern && !pattern.isMatchPattern) {
                    env.taskQueue.splice(index--, 1);
                    removed = true;
                }
            }
            if (!removed) {
                env.taskIndexes[pattern.toString()] = index;
            }
            else {
                delete env.taskIndexes[pattern.toString()];
            }
        }
    }
    function pushTaskQueue(pattern, callback) {
        var id = pattern.toString();
        var taskIndex = env.taskIndexes[id];
        if (shared_1.isValid(taskIndex)) {
            if (env.taskQueue[taskIndex] &&
                !env.taskQueue[taskIndex].callbacks.some(function (fn) {
                    return fn.toString() === callback.toString() ? fn === callback : false;
                })) {
                env.taskQueue[taskIndex].callbacks.push(callback);
            }
        }
        else {
            env.taskIndexes[id] = env.taskQueue.length;
            env.taskQueue.push({
                pattern: pattern,
                callbacks: [callback]
            });
        }
    }
    function init(actions) {
        heart.publish(types_1.LifeCycleTypes.ON_FORM_WILL_INIT, form, actions);
        graph.appendNode(form);
        form.setState(function (state) {
            state.initialized = true;
            if (shared_1.isValid(options.initialValues)) {
                state.initialValues = shared_1.clone(options.initialValues);
            }
            if (shared_1.isValid(options.values)) {
                state.values = shared_1.clone(options.values);
            }
            if (!shared_1.isValid(state.values)) {
                state.values = state.initialValues;
            }
            if (shared_1.isValid(options.editable)) {
                state.editable = options.editable;
            }
        });
    }
    function hostUpdate(callback, forceUpdate) {
        if (shared_1.isFn(callback)) {
            env.hostRendering = true;
            var result = callback();
            if (env.hostRendering || forceUpdate) {
                heart.publish(types_1.LifeCycleTypes.ON_FORM_HOST_RENDER, form);
            }
            env.hostRendering = false;
            return result;
        }
    }
    function nextTick(callback) {
        setTimeout(callback);
    }
    function afterUnmount(callback) {
        clearTimeout(env.unmountTimer);
        env.unmountTimer = setTimeout(callback, 1000);
    }
    function isHostRendering() {
        return env.hostRendering;
    }
    function disableUnmountClearStates(pattern) {
        if (pattern === void 0) { pattern = '*'; }
        var path = shared_1.FormPath.parse(pattern);
        env.clearStatesPatterns[path.toString()] = false;
    }
    function enableUnmountClearStates(pattern) {
        if (pattern === void 0) { pattern = '*'; }
        var path = shared_1.FormPath.parse(pattern);
        env.clearStatesPatterns[path.toString()] = true;
    }
    function disableUnmountRemoveNode() {
        env.unmountRemoveNode = false;
    }
    function enableUnmountRemoveNode() {
        env.unmountRemoveNode = true;
    }
    function supportUnmountClearStates(path) {
        for (var pattern in env.clearStatesPatterns) {
            var enable = env.clearStatesPatterns[pattern];
            if (matchStrategy(pattern, path)) {
                return enable;
            }
        }
        return true;
    }
    function upload(callback) {
        env.uploading = true;
        callback();
        env.uploading = false;
    }
    var graph = new graph_1.FormGraph({
        matchStrategy: matchStrategy
    });
    var form = new form_1.Form();
    var validator = new validator_1.FormValidator(__assign(__assign({}, options), { matchStrategy: matchStrategy }));
    var heart = new lifecycle_1.FormHeart(__assign(__assign({}, options), { beforeNotify: function (payload) {
            env.publishing[payload.path || ''] = true;
        }, afterNotify: function (payload) {
            env.publishing[payload.path || ''] = false;
        } }));
    var env = {
        validateTimer: null,
        unmountTimer: null,
        syncFormStateTimer: null,
        onChangeTimer: null,
        graphChangeTimer: null,
        hostRendering: false,
        publishing: {},
        taskQueue: [],
        uploading: false,
        taskIndexes: {},
        realRemoveTags: [],
        lastShownStates: {},
        clearStatesPatterns: {},
        unmountRemoveNode: false,
        submittingTask: undefined
    };
    form.subscription = {
        notify: onFormChange
    };
    graph.subscribe(onGraphChange);
    return {
        options: options,
        init: init,
        form: form,
        graph: graph,
        validator: validator,
        heart: heart,
        env: env,
        upload: upload,
        nextTick: nextTick,
        afterUnmount: afterUnmount,
        getDataPath: getDataPath,
        getFormValuesIn: getFormValuesIn,
        getFormInitialValuesIn: getFormInitialValuesIn,
        setFormValuesIn: setFormValuesIn,
        setFormInitialValuesIn: setFormInitialValuesIn,
        existFormValuesIn: existFormValuesIn,
        deleteFormValuesIn: deleteFormValuesIn,
        updateRecoverableShownState: updateRecoverableShownState,
        disableUnmountClearStates: disableUnmountClearStates,
        enableUnmountClearStates: enableUnmountClearStates,
        supportUnmountClearStates: supportUnmountClearStates,
        enableUnmountRemoveNode: enableUnmountRemoveNode,
        disableUnmountRemoveNode: disableUnmountRemoveNode,
        resetFormMessages: resetFormMessages,
        syncFormMessages: syncFormMessages,
        batchRunTaskQueue: batchRunTaskQueue,
        pushTaskQueue: pushTaskQueue,
        hostUpdate: hostUpdate,
        isHostRendering: isHostRendering
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/internals.js
// module id = 4641
// module chunks = 0